export default {
      id: "svg-icon-loop-usage",
      viewBox: "0 0 28 29",
      url: __webpack_public_path__ + "static/images/svg-icons.svg#svg-icon-loop",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-svg/loop.svg
// module id = sfGt
// module chunks = 4